<template>
  <div v-if="!name">
    <h5 class="mb-8">Action executed</h5>
    <ul class="flex flex-col">
      <li v-for="(value, key) in actions" :key="key" class="mt-2">
        <button class="btn btn-success w-full" @click="$emit('update-name', value.name)">
          {{ value.displayName }}
        </button>
      </li>
    </ul>
  </div>
  <div v-else>
    <h6 class="font-normal text-base mb-8">
      Then <span class="font-medium">{{ action.displayName }}</span>
    </h6>
    <component
      :is="component"
      :project-uuid="projectUuid"
      :account-uuid="accountUuid"
      :default-data="props || {}"
      @update-props="$emit('update-props', $event)"
    />
  </div>
</template>

<script>
import { upperFirst, camelCase } from 'lodash-es';

const CONTACT_REQUEST_ENTER_PIPELINE = 'contact_request.enter.pipeline';
const CONTACT_REQUEST_UPDATE_FIELD = 'contact_request.update.field';
const CONTACT_REQUEST_SEND_EMAIL = 'contact_request.send.email';
const CONTACT_REQUEST_SEND_SMS = 'contact_request.send.sms';
const CONTACT_REQUEST_NOTIFY_SOMEONE = 'contact_request.notify.someone';
const CONTACT_REQUEST_ASSIGN_MEMBER = 'contact_request.assign.member';
const CONTACT_REQUEST_ADD_TAG = 'contact_request.add.tag';

const ACTIONS = {
  [CONTACT_REQUEST_ENTER_PIPELINE]: {
    name: CONTACT_REQUEST_ENTER_PIPELINE,
    displayName: 'Enter Contact Request to a pipeline',
  },
  [CONTACT_REQUEST_UPDATE_FIELD]: {
    name: CONTACT_REQUEST_UPDATE_FIELD,
    displayName: 'Update Contact Request field',
  },
  [CONTACT_REQUEST_SEND_EMAIL]: {
    name: CONTACT_REQUEST_SEND_EMAIL,
    displayName: 'Send email to Contact Request',
  },
  [CONTACT_REQUEST_SEND_SMS]: {
    name: CONTACT_REQUEST_SEND_SMS,
    displayName: 'Send SMS to Contact Request',
  },
  [CONTACT_REQUEST_NOTIFY_SOMEONE]: {
    name: CONTACT_REQUEST_NOTIFY_SOMEONE,
    displayName: 'Notify Someone about the Contact Request',
  },
  [CONTACT_REQUEST_ASSIGN_MEMBER]: {
    name: CONTACT_REQUEST_ASSIGN_MEMBER,
    displayName: 'Assign Contact Request to a Member',
  },
  [CONTACT_REQUEST_ADD_TAG]: {
    name: CONTACT_REQUEST_ADD_TAG,
    displayName: 'Add Tags to Contact Request',
  },
};

export default {
  props: {
    projectUuid: { type: String, required: true },
    accountUuid: { type: String, required: true },
    name: { type: String, default: null },
    props: { type: Object, default: null },
  },

  data() {
    return {
      actions: { ...ACTIONS },
    };
  },

  computed: {
    action() {
      if (!this.name) return null;

      return ACTIONS[this.name] || null;
    },
    component() {
      if (!this.action) return null;

      const componentName = upperFirst(camelCase(this.action.name));

      return () => import(`./Actions/${componentName}.vue`);
    },
  },
};
</script>
